// app/ClientWrapper.tsx
"use client";
import {useSmoothScroll} from "@/context/SmoothScrollContext";
import {useEffect} from "react";
import {LazyMotion, domAnimation} from "framer-motion";

export default function ClientWrapper({children}: {children: React.ReactNode}) {
  const {lenis} = useSmoothScroll();

  useEffect(() => {
    console.log("ClientWrapper mounted with lenis:", !!lenis);
  }, [lenis]);

  return (
    <LazyMotion features={domAnimation}>
      {children}
    </LazyMotion>
  );
}
